// removed by extract-text-webpack-plugin
module.exports = {"base":"ReserveActivationTimer_base--3V7F_","time":"ReserveActivationTimer_time--3x6_s"};


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/ReserveActivationTimer/ReserveActivationTimer.scss
// module id = 2196
// module chunks = 11